import axios from 'axios';
const root = '/api/playable_intake/pure/ebay';
const r = id => `${root}/receipts/${id}`;
export const queue = (batchId) => axios.get(`${root}/queue`, { params: batchId ? { batch_id: batchId } : {} });
export const detail = id => axios.get(r(id));
export const bind = (id, data) => axios.post(`${r(id)}/bind`, data);
export const policyReview = (id, data) => axios.post(`${r(id)}/policy_review`, data);
export const preview = (id, data) => axios.post(`${r(id)}/preview`, data);
export const approve = (id, data) => axios.post(`${r(id)}/approve`, data);
export const inspectDraftCandidate = (id, data) => axios.post(`${r(id)}/inspect_draft_candidate`, data);
export const repairOfferLink = (id, data) => axios.post(`${r(id)}/repair_offer_link`, data);
export const draft = (id, data) => axios.post(`${r(id)}/draft`, data);
export const verifyDraft = id => axios.post(`${r(id)}/verify_draft`, {});

export const verifyCompetingFinish = (id, data) => axios.post(`${r(id)}/verify_competing_finish`, data);

export const inspectUncertain = id => axios.get(`${r(id)}/reconciliation`);
export const rearmUncertain = (id,data) => axios.post(`${r(id)}/reconciliation/rearm`,data);

export const correctListingFinish = (id,data) => axios.post(`${r(id)}/correct_listing_finish`,data);
export const metrics = batchId => axios.get(`${root}/metrics`,{params:batchId?{batch_id:batchId}:{}});
